import PropTypes from 'prop-types';

import './styles/mediaBodyStyles.css';

const MediaBody = ({ children, ...rest }) => (
  <div className="media-body" {...rest}>
    {children}
  </div>
);

MediaBody.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MediaBody;
